<div class="flex align-items-center justify-content-center date-slide">
    <p-button size="large" (click)="prev()" icon="pi pi-angle-left" [rounded]="true" [text]="true"></p-button>
    <div class="date" *ngIf="type =='month-year'">{{date | date:'MMMM YYYY'}}</div>
    <div class="date" *ngIf="type =='year'">{{date | date:'YYYY'}}</div>
    <p-button size="large" (click)="next()" icon="pi pi-angle-right" [rounded]="true" [text]="true"></p-button>
</div>
